import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
	root: {
		marginBottom: '12px',
	},
	total: {
		color: '#008EA6',
		fontSize: '22px',
		fontFamily: 'Roboto',
		fontWeight: 'bold',
	},
	totalValue: {
		color: '#4D4D4D',
		fontSize: '24px',
		fontFamily: 'Roboto',
		fontWeight: 'bold',
	},
	segregated: {
		color: '#B26A00',
		fontSize: '18px',
		fontFamily: 'Roboto',
		fontWeight: 'bold',
	},
	segregatedValue: {
		color: '#B26A00',
		fontSize: '20px',
		fontFamily: 'Roboto',
		fontWeight: 'bold',
	},
});

const Totals = ({ total, segregated, classes }) => (
	<Grid container direction="column" className={classes.root}>
		<Grid container justify="space-between">
			<Typography className={classes.total}>Total</Typography>
			<Typography className={classes.totalValue}>{total} unidades</Typography>
		</Grid>
		{segregated > 0 && (
			<Grid container justify="space-between">
				<Typography className={classes.segregated}>Segregado</Typography>
				<Typography className={classes.segregatedValue}>{segregated} unidades</Typography>
			</Grid>
		)}
	</Grid>
);

Totals.defaultProps = {
	segregated: 0,
};

export default withStyles(styles)(Totals);
